/**
 * strap-rules.js — conditional UI (deriveUI) + resolveLayers (state -> ordered <img> layer list).
 * Every layer is an image (like the buckle); recolour = swap to the pre-rendered coloured image.
 */
(function (SB) {
  'use strict';
  var M = function () { return SB.MANIFEST; };

  function imgIn(arr, id) { var c = (arr || []).find(function (x) { return x.id === id; }); return c ? c.img : null; }

  SB.deriveUI = function (state) {
    var st = SB.selectors.styleDef(state);
    var lea = SB.selectors.leather(state);
    var keeperOk = lea.keeperCustom !== false;   // some leathers (ostrich) have no custom keeper/edge
    var edgeOk = lea.edgeCustom !== false;
    return {
      visible: {
        underlayColor: st.needsUnderlay,
        edgeMode: edgeOk,
        edgeColor: edgeOk && state.edgeMode === 'custom',
        keeperMode: keeperOk,
        keeperColor: keeperOk && state.keeperMode === 'custom'
      },
      required: { underlayColor: st.needsUnderlay }
    };
  };

  SB.resolveLayers = function (state) {
    var m = M();
    var lea = SB.selectors.leather(state);
    var color = SB.selectors.color(state);
    var st = SB.selectors.styleDef(state);
    // stitch/holes masks are per-leather (the strap silhouettes differ) — filename = prefix + colour.
    var stitchPre = lea.stitchPrefix || 'sb-stitch-';
    var holesPre = lea.holesPrefix || 'sb-holes-';
    var keeperOk = lea.keeperCustom !== false;
    var edgeOk = lea.edgeCustom !== false;

    var layers = {
      base: { kind: 'img', src: color.base },
      // edge/keeper are baked into the base in the leather colour; overlay a coloured image only on
      // a custom choice (tone-on-tone = the base already shows them).
      edge: edgeOk && state.edgeMode === 'custom' ? { kind: 'img', src: imgIn(m.edgeColors, state.edgeColor) } : null,
      holes: st.needsUnderlay ? { kind: 'img', src: holesPre + state.underlayColor + '.webp' } : null,
      // Keeper. Tone-on-tone = show the strap's OWN keeper (already in the base photo: true colour +
      // grain + lighting) by drawing nothing. Custom = cover it with the opaque grey keeper texture
      // + the chosen colour blended on via mix-blend-mode:overlay @65% (owner's PTS recipe).
      keeperTex: keeperOk && state.keeperMode === 'custom' ? { kind: 'img', src: m.keeperTexture } : null,
      keeperColor: keeperOk && state.keeperMode === 'custom' ? { kind: 'img', src: imgIn(m.keeperColors, state.keeperColor) } : null,
      stitch: { kind: 'img', src: stitchPre + state.stitchColor + '.webp' },
      buckle: { kind: 'img', src: buckle(state).img }
    };
    return m.layerOrder
      .map(function (name) { var d = layers[name]; return (d && d.src) ? Object.assign({ layer: name }, d) : null; })
      .filter(Boolean);
  };

  function buckle(state) { return M().buckles.find(function (b) { return b.id === state.buckleId; }) || M().buckles[0]; }
})(window.StrapBuilder = window.StrapBuilder || {});
